import styled from 'styled-components';
import { media } from 'designsystem';

const SlideWrapper = styled.div`    
    display: flex;
    flex-flow: row;
    width:100%;
    
    ${media.desktop`
        width:125%;
        transform: scale(1);
        transition: transform 0.5s ease;
        transform-origin: 0 50%;
        & > div .slick-list{
            overflow: visible;
            & .slick-track{
                margin-left:0;
            }
        }
        &:hover{
            transform: scale(0.99, 1);
            transform-origin: 0 50%;
            transition: transform 0.5s ease;
            cursor:pointer;
        }
    `};
`;

export default SlideWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ProductSlider/SlideWrapper.jsx